import React, { useEffect, useState } from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'
import { Amazon } from 'grommet-icons'


const AWSConsoleButtonRenderer = params => {
    return (
        <Box
            fill
            pad="xsmall"
            direction="row"
            onClick={() => {
                if (params.node.data.DirectLink) {
                    window.open(params.node.data.DirectLink)
                }

            }}
        >
            <Text size='xsmall'><Amazon size="11px" /> AWS Console</Text>
        </Box>
    )
}

const HealthStatusServiceAlarms = ({ data }) => {

    const [tabData, setTabData] = useState([])

    useEffect(() => {
        if (data) {
            let tmpData = []
            data.forEach(row => {
                row.uniqueId = row.AlarmArn
                tmpData.push(row)
            })
            setTabData(tmpData)
        }
    }, [data])

    const tab_col = [
        {
            field: "AlarmArn",
            headerName: "ARN",
            suppressSizeToFit: true,
            minWidth: 150,
            hide: true,
            cellStyle: function (params) {
                if (params.node.data.StateValue === 'ALARM') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else if (params.node.data.StateValue === 'INSUFFICIENT_DATA') {
                    return { color: 'black', backgroundColor: '#FDFB98' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            }
        },
        {
            field: "AlarmName",
            headerName: "Alarm Name",
            minWidth: 150,
            suppressSizeToFit: true,
            cellStyle: function (params) {
                if (params.node.data.StateValue === 'ALARM') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else if (params.node.data.StateValue === 'INSUFFICIENT_DATA') {
                    return { color: 'black', backgroundColor: '#FDFB98' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            }
        },
        {
            field: "Statistic",
            headerName: "Statistic",
            minWidth: 150,
            suppressSizeToFit: true,
            cellStyle: function (params) {
                if (params.node.data.StateValue === 'ALARM') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else if (params.node.data.StateValue === 'INSUFFICIENT_DATA') {
                    return { color: 'black', backgroundColor: '#FDFB98' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            }
        },
        {
            field: "Threshold",
            headerName: "Threshold",
            minWidth: 150,
            suppressSizeToFit: true,
            cellStyle: function (params) {
                if (params.node.data.StateValue === 'ALARM') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else if (params.node.data.StateValue === 'INSUFFICIENT_DATA') {
                    return { color: 'black', backgroundColor: '#FDFB98' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            }
        },
        {
            field: "MetricName",
            headerName: "Metrics Name",
            minWidth: 150,
            suppressSizeToFit: true,
            cellStyle: function (params) {
                if (params.node.data.StateValue === 'ALARM') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else if (params.node.data.StateValue === 'INSUFFICIENT_DATA') {
                    return { color: 'black', backgroundColor: '#FDFB98' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            }
        },
        {
            field: "StateValue",
            headerName: "Status",
            minWidth: 150,
            suppressSizeToFit: true,
            sort: 'asc',
            cellStyle: function (params) {
                if (params.node.data.StateValue === 'ALARM') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else if (params.node.data.StateValue === 'INSUFFICIENT_DATA') {
                    return { color: 'black', backgroundColor: '#FDFB98' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            }
        },
        {
            field: "StateReason",
            headerName: "Reason",
            minWidth: 150,
            suppressSizeToFit: true,
            cellStyle: function (params) {
                if (params.node.data.StateValue === 'ALARM') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else if (params.node.data.StateValue === 'INSUFFICIENT_DATA') {
                    return { color: 'black', backgroundColor: '#FDFB98' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            }
        },
        {
            field: "AlarmDescription",
            headerName: "Description",
            minWidth: 150,
            suppressSizeToFit: true,
            hide: true,
            cellStyle: function (params) {
                if (params.node.data.StateValue === 'ALARM') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else if (params.node.data.StateValue === 'INSUFFICIENT_DATA') {
                    return { color: 'black', backgroundColor: '#FDFB98' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            }
        },
        {
            field: "DirectLink",
            headerName: "AWS Console",
            minWidth: 150,
            suppressSizeToFit: true,
            cellRenderer: AWSConsoleButtonRenderer
        }
    ]

    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold"> Sessions </Text>

            <AgDataTable
                tab_col={tab_col}
                tab_data={tabData}
                tableName="HealthStatusServiceAlarms"
                tableHeight={700}
            />

        </Box>
    )
}

export default HealthStatusServiceAlarms